import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-views-common/table";
import { VALID_PAGE_SIZES } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getFulfillmentGroupSummaries = {
  name: "getFulfillmentGroupSummaries" as const,
  skipOutputValidation: true,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z
      .number()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
